var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.667 7.569h10.667v11.733H6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90929C",
    d: "M15.457 6.933C15.15 5.266 13.718 4 12 4c-1.718 0-3.15 1.266-3.457 2.933H6.667A.667.667 0 0 0 6 7.6v11.733c0 .368.298.667.667.667h10.666a.667.667 0 0 0 .667-.667V7.6a.667.667 0 0 0-.667-.667h-1.876zM12 5.333c.982 0 1.814.675 2.09 1.6H9.91c.276-.925 1.108-1.6 2.09-1.6zm4.667 13.334H7.333v-10.4H8.48V9.43a.667.667 0 0 0 1.334 0V8.267h4.373V9.43a.667.667 0 0 0 1.333 0V8.267h1.147v10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90929C",
    d: "M15.21 15.001a.667.667 0 0 0-.667.667v.8h-.76a.667.667 0 0 0 0 1.334h1.427a.667.667 0 0 0 .667-.667v-1.467A.667.667 0 0 0 15.21 15z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.034c68d2f51e73cc8261930cd55b954f.svg";
export { ForwardRef as ReactComponent };